import _typeof from 'babel-runtime/helpers/typeof';
var hasDocument = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document !== null;
var hasWindow = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window !== null && window.self === window;

export default hasDocument && hasWindow;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/isBrowser.js
// module id = 511
// module chunks = 0